var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container stretched-container" }, [
    _c("div", { staticClass: "tag-timer" }, [
      _vm.banner
        ? _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col-auto p-0" }, [
              _c("div", { staticClass: "ob1-tag ob1-tag-primary" }, [
                _c("span", [_vm._v(_vm._s(_vm.banner))]),
              ]),
            ]),
            _vm._v(" "),
            _vm.timerEndDateInMilliseconds
              ? _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c("timer", {
                      attrs: {
                        "end-date-in-milliseconds":
                          _vm.timerEndDateInMilliseconds,
                        color: _vm.countDownColor,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }